import * as React from "react";
import PropTypes from 'prop-types';

const SvgAccountApollo = props => {
  if (props.id !== "_svgaccountapollo") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><path fillRule="evenodd" d="M16 27.2C9.814 27.2 4.8 22.186 4.8 16 4.8 9.814 9.814 4.8 16 4.8c6.186 0 11.2 5.014 11.2 11.2 0 6.186-5.014 11.2-11.2 11.2m0-20.534c5.154 0 9.334 4.18 9.334 9.334 0 2.632-1.09 5.01-2.842 6.706-.14-.744-.642-1.379-1.367-1.715l-2.748-1.275c-.284-.132-.447-.378-.447-.64v-.345c1.194-.901 1.937-2.505 1.937-4.264 0-2.743-1.799-5-4.067-5-2.269 0-4.067 2.257-4.067 5 0 1.816.792 3.464 2.05 4.346v.237c0 .252-.155.494-.42.628l-2.567 1.3a2.457 2.457 0 00-1.289 1.727A9.304 9.304 0 016.667 16c0-5.154 4.179-9.334 9.333-9.334" /></svg>;
};

SvgAccountApollo.displayName = "_svgaccountapollo";
SvgAccountApollo.propTypes = {
  id: PropTypes.string
};
SvgAccountApollo.defaultProps = {
  id: ''
};
export default SvgAccountApollo;